module.exports = __webpack_public_path__ + "static/media/cont34.a8d7af5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34.mp4
// module id = cROS
// module chunks = 0